var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var Matrix = /** @class */ (function () {
    function Matrix(_values, metaMatrix) {
        this._values = _values;
        this.metaMatrix = metaMatrix;
    }
    Matrix.prototype.setAt = function (index, newValue) {
        var newMatrix = this.clone();
        newMatrix._values[index] = newValue;
        return newMatrix;
    };
    Matrix.prototype.get = function (row, col) {
        var i = row * this.metaMatrix.cols + col;
        return this.at(i);
    };
    Matrix.prototype.at = function (i) {
        return this._values[i];
    };
    Matrix.prototype.getRow = function (i) {
        var _this = this;
        return this.metaMatrix.row(i).map(function (location) { return _this.at(location.index); });
    };
    Matrix.prototype.getRows = function () {
        var _this = this;
        return Array.from(Array(this.metaMatrix.rows).keys()).map(function (i) {
            return _this.getRow(i);
        });
    };
    Matrix.prototype.getCol = function (i) {
        var _this = this;
        return this.metaMatrix.col(i).map(function (location) { return _this.at(location.index); });
    };
    Matrix.prototype.getCols = function () {
        var _this = this;
        return Array.from(Array(this.metaMatrix.cols).keys()).map(function (i) {
            return _this.getCol(i);
        });
    };
    Matrix.prototype.clone = function () {
        return new Matrix(this.values, this.metaMatrix);
    };
    Object.defineProperty(Matrix.prototype, "values", {
        get: function () {
            return __spreadArray([], this._values, true);
        },
        enumerable: false,
        configurable: true
    });
    Matrix.prototype.equals = function (matrix) {
        var _this = this;
        if (!matrix.metaMatrix.equals(this.metaMatrix)) {
            return false;
        }
        var indices = this.metaMatrix.all().map(function (loc) { return loc.index; });
        return indices.every(function (index) { return matrix.at(index) === _this.at(index); });
    };
    Matrix.init = function (metaMatrix, value) {
        return new Matrix(Array(metaMatrix.rows * metaMatrix.cols).fill(value), metaMatrix);
    };
    Matrix.prototype.toString = function () {
        return "" + this.metaMatrix.cols + this.metaMatrix.rows + this._values.join("");
    };
    return Matrix;
}());
export { Matrix };
var MetaMatrix = /** @class */ (function () {
    function MetaMatrix(rows, cols) {
        this.rows = rows;
        this.cols = cols;
    }
    MetaMatrix.prototype.index = function (i) {
        return {
            index: i,
            row: Math.floor(i / this.rows),
            col: i % this.cols
        };
    };
    MetaMatrix.prototype.all = function () {
        var _this = this;
        return Array.from(Array(this.rows * this.cols).keys()).map(function (i) {
            return _this.index(i);
        });
    };
    MetaMatrix.prototype.col = function (c) {
        var _this = this;
        return Array.from(Array(this.rows).keys()).map(function (i) {
            return _this.index(c + _this.cols * i);
        });
    };
    MetaMatrix.prototype.row = function (r) {
        var _this = this;
        return Array.from(Array(this.cols).keys()).map(function (i) {
            return _this.index(i + _this.cols * r);
        });
    };
    MetaMatrix.prototype.allRows = function () {
        var _this = this;
        return Array.from(Array(this.rows).keys()).map(function (i) { return _this.row(i); });
    };
    MetaMatrix.prototype.equals = function (metaMatrix) {
        return metaMatrix.cols === this.cols && metaMatrix.rows === this.rows;
    };
    return MetaMatrix;
}());
export { MetaMatrix };
